import React from 'react';

import { Props as DialogProps } from '@smart-tv/components/dialog/dialog';

import { PlayerDevicesProvider } from './player-devices-context';
import PlayerDevicesDialog from './player-devices-dialog/player-devices-dialog';

export interface Props extends Omit<DialogProps, 'children'> {
  mediaId?: number;
  onRefreshStream: () => void;
  sid?: number;
}

export const PlayerDevices: React.FC<Props> = (props: Props) => {
  if (!props.open) return null;

  return (
    <PlayerDevicesProvider {...props}>
      <PlayerDevicesDialog />
    </PlayerDevicesProvider>
  );
};

export default React.memo(PlayerDevices);
